/** Typed fetch wrapper. The token lives in localStorage (per-device, 30-day JWT); every error is normalised to ApiFail. */
export const API = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? 'http://localhost:8787';
const KEY = 'konkride.token';

export class ApiFail extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}
export const tokenStore = {
  get: (): string | null => { try { return localStorage.getItem(KEY); } catch { return null; } },
  set: (t: string) => { try { localStorage.setItem(KEY, t); } catch { /* private mode */ } },
  clear: () => { try { localStorage.removeItem(KEY); } catch { /* private mode */ } },
};

type Init = { method?: string; json?: unknown; body?: BodyInit; headers?: Record<string, string>; signal?: AbortSignal };
export async function api<T = any>(path: string, init: Init = {}): Promise<T> {
  const headers: Record<string, string> = { ...init.headers };
  const t = tokenStore.get();
  if (t) headers.authorization = `Bearer ${t}`;
  let body = init.body;
  if (init.json !== undefined) { headers['content-type'] = 'application/json'; body = JSON.stringify(init.json); }
  let res: Response;
  try { res = await fetch(API + path, { method: init.method ?? (body ? 'POST' : 'GET'), headers, body: body ?? null, signal: init.signal ?? null }); }
  catch { throw new ApiFail(0, 'network', 'No connection. Check your network and try again.'); }
  const text = await res.text();
  let data: any = null; try { data = text ? JSON.parse(text) : null; } catch { /* non-JSON */ }
  if (!res.ok) {
    if (res.status === 401 && data?.error?.code !== 'wrong_login') tokenStore.clear();
    throw new ApiFail(res.status, data?.error?.code ?? 'error', data?.error?.message ?? 'Something went wrong. Try again.');
  }
  return data as T;
}

export async function upload(kind: string, file: File): Promise<string> {
  const r = await api<{ id: string }>(`/uploads?kind=${encodeURIComponent(kind)}`, { method: 'POST', body: file, headers: { 'content-type': file.type || 'application/octet-stream' } });
  return r.id;
}

